module.exports = new __parcel__URL__("DAS-Shapes-Chaos.709a74a5.svg").toString();